import script from "./RotulosForm_18.vue?vue&type=script&setup=true&lang=js"
export * from "./RotulosForm_18.vue?vue&type=script&setup=true&lang=js"

import "./RotulosForm_18.vue?vue&type=style&index=0&id=3edbe88e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edbe88e"]])

export default __exports__